import cn from "classnames";
import Link from "next/link";
import s from "./Tags.module.scss";

const Tag = ({ className, text, to, ...props }) => {
  return to ? (
    <Link href={to} className={cn(s.tag, className)} {...props}>
      {text}
    </Link>
  ) : (
    <div className={cn(s.tag, className)} {...props}>
      {text}
    </div>
  );
};

export default Tag;
